import { connect } from 'react-redux';
import { STEP_TWO_LOCATIONS, STEP_TWO_PRODUCTS } from 'feature/loading-management/utils/const';
import SelectProducts from '../../../create-new-common/SelectProducts';
import {
  getAllEnabled,
  getIdentifier,
  getInactiveListOptions,
  setEnabledOptions,
} from '../../store/createNewSelfAuthorizationSlice';

const mapState = state => {
  const isProducts = !!state.loadingManagement.createNewSelfAuth.params.locationId;
  const identifier = getIdentifier(state);
  const toggleAllMessage = `Turn On All ${isProducts ? 'Products' : 'Locations'}?`;

  return {
    allEnabled: getAllEnabled(state),
    header: `${isProducts ? STEP_TWO_PRODUCTS : STEP_TWO_LOCATIONS}${identifier}?`,
    inactiveListOptions: getInactiveListOptions(state),
    toggleAllMessage,
  };
};

// put action functions here, will choose correct one in mergeProps
const mapDispatchToProps = {
  setEnabledOptions,
};

export default connect(mapState, mapDispatchToProps)(SelectProducts);
